module.exports = __webpack_public_path__ + "static/media/phone.ccdc069e.svg";